import type { Step } from "react-joyride";

export const productsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການສິນຄ້າ. ຫນ້ານີ້ຊ່ວຍທ່ານຈັດການສິນຄ້າ, ຄົ້ນຫາ, ກອງຕາມສະຖານະ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="products-toolbar"]',
    content: "ປຸ່ມສ້າງສິນຄ້າໃໝ່. ກົດເພື່ອເພີ່ມສິນຄ້າ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="products-filter"]',
    content:
      "ກອງຂໍ້ມູນ: ຄົ້ນຫາຊື່/SKU/slug, ກອງຕາມສະຖານະ (ແບບຮ່າງ/ເປີດໃຊ້ງານ/ເກັບຖາວອນ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="products-table"]',
    content:
      "ຕາຕະລາງສິນຄ້າ. ສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ຫຼື ລຶບສິນຄ້າໄດ້ຈາກປຸ່ມການກະທໍາ.",
    placement: "top",
  },
];
